<template>
  <div id="rateassist-details-t">
    <div class="row">
      <div class="col-xs-12">
        <div class="shadow clearfix">
          <hr class="hr-text" data-content="Notes"/>
          <div class="col-xs-12 col-md-6">
            <div class="form-group">
              <label for="note-title" class="form-label">Title</label>
              <input class="form-control" id="note-title" v-model="note.title" />
            </div>
          </div>
          <div class="col-xs-12 col-md-6">
            <div class="form-group">
              <label for="note-text" class="form-label">Note text</label>
              <textarea class="form-control" id="note-text" v-model="note.noteText"></textarea>
            </div>
          </div>

          <div class="col-xs-12">
            <hr>
            <div class="pull-right">
              <div class="btn btn-success" @click="save">
                {{ saveOrUpdate }}
              </div>
              <div class="btn btn-danger" @click="doClear">
                Clear
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xs-12">
        <vue-table
          :tableData="notes"
          tableTitle="Notes"
          v-on:table-edit-request="updateActive"
          :showEdit="true"
          v-on:table-delete-request="doDelete"
          :showDelete="true"
          :fields="[
          { header: 'Title', prop: 'title' },
          { header: 'Note', prop: 'noteText' }
          ]"
        ></vue-table>
      </div>
    </div>
  </div>
</template>
<script>
  import LookupHelperMixin from '../../mixins/Helpers'
  import VueTable from '../../../helpers/VueTable.vue'
  import API from '../../../../api/endpoints'
  import event from '../../../../event'
  export default {
    name: 'TariffNotes',
    props: ['notesProp', 'lookup'],
    mixins: [ LookupHelperMixin ],
    components: {
      VueTable
    },
    data () {
      return {
        notes: [],
        canEmit: true,
        note: {
          id: null,
          title: '',
          noteText: '',
          lookup: null
        }
      }
    },
    computed: {
      saveOrUpdate () {
        return this.note.id !== null ? 'Update' : 'Save'
      },
      saveUrl () {
        return this.note.id ? API.UPDATE_ADMIN_ENTITY('note', this.note.id) : API.CREATE_ADMIN_ENTITY('note')
      },
      saveMethod () {
        return this.note.id ? 'put' : 'post'
      },
      isUpdate () {
        return this.note.id !== null
      }
    },
    watch: {
      notes: {
        deep: true,
        handler: function (newVal, oldVal) {
          this.$emit('updating', newVal)
        }
      },
      notesProp: {
        deep: true,
        handler: function (newVal, oldVal) {
          if (JSON.stringify(newVal) !== JSON.stringify(this.notes)) {
            this.notes = newVal
          }
        }
      }
    },
    methods: {
      deCamel (string) {
        return string.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())
      },
      doDelete ({ item, index }) {
        this.$http.delete(API.DELETE_ADMIN_ENTITY('note', item.id))
        .then(res => {
          let i = this.notes.findIndex(({id}) => id === item.id)
          if (i > -1) {
            this.notes.splice(i, 1)
          }
          event.$emit('toast', { type: 'success', message: 'Tariff Note Deleted' })
          this.doClear()
        }).catch(err => {
          event.$emit('toast', { type: 'error', message: err.message })
          console.log(err)
        })
      },
      save () {
        this.note.lookup = this.lookup
        let msg = this.isUpdate ? 'Tariff Note Updated' : 'Note Added to Tariff'
        this.$http[this.saveMethod](this.saveUrl, this.note)
        .then(({data}) => {
          if (data.hasOwnProperty('id')) {
            this.note.id = data.id
            this.addToList({ ...this.note })
            event.$emit('toast', { type: 'success', message: msg })
          }
        }).catch(err => {
          event.$emit('toast', { type: 'error', message: err.message })
          console.log(err)
        })
      },
      addToList (de) {
        let i = this.notes.findIndex(d => d.id === de.id)
        if (i === -1) {
          this.notes.push(de)
        } else {
          for (let prop in de) {
            this.notes[i][prop] = de[prop]
          }
        }
        this.doClear()
      },
      doClear () {
        this.$nextTick(() => {
          let item = {
            id: null,
            title: '',
            noteText: '',
            lookup: null
          }
          this.updateActive({ item, index: null })
        })
      },
      updateActive ({ item, index }) {
        for (let prop in item) {
          this.note[prop] = item[prop]
        }
      },
      sortedOptions (type) {
        return this.getSystemOptions(type).sort((a, b) => {
          return a.name < b.name ? -1 : a.name > b.name ? 1 : 0
        })
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/modules/admin/components/Tariff/TariffNotes.vue